import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react';
import {
  TextField,
  Typography,
  Box,
  Button,
  DialogActions,
  FormControlLabel,
  Switch,
} from '@mui/material';

import { convertFormData } from '../../utils/form';
import { PushNotification, Camp } from '../../generated/graphql';
import { FullWidthForm } from '../common/CommonDivs';
import { useStores } from '../../stores';

interface CreatePushNotificationProps {
  onSubmit: (data) => void;
  onCancel: () => void;
  existingItem?: PushNotification;
  camp: Camp;
  permissions: any
}
export const CreatePushNotification = observer(function CreatePushNotification({
  onSubmit,
  onCancel,
  existingItem,
  camp,
  permissions
}: CreatePushNotificationProps) {
  const stores = useStores();
  const modalStore = stores.modalStore;
  const [state, setState] = useState({});


  const isEdit = !!existingItem;
  const [restrictedAudience, setRestrictedAudience] = useState(false);

  useEffect(() => {
    if (!existingItem) return;
    setRestrictedAudience(existingItem.restrictedAudience);
  }, [existingItem]);

  useEffect(() => {


    console.log('existingItem', existingItem);
    

    let itemPermissions = [];

    if (existingItem && existingItem.permissions)
    {
      itemPermissions = JSON.parse(existingItem.permissions);
    }

    permissions.map(item => {
      setState((s) => ({
        ...s,
        [item.id]: itemPermissions[item.id],
      }));
    })

  }, [permissions, existingItem]);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const data = convertFormData(e.target);

    //if creating new push, warn the user.
    if (!isEdit) {
      const confirmed = await modalStore.confirm(
        'Är du säker på att du vill skicka en notis till ' + camp.name,
      );
      if (!confirmed) return;
    }

    data.restrictedAudience = restrictedAudience;
    data.permissions = JSON.stringify(state);
    onSubmit(data);
  };

  return (
    <Box p={4} paddingBottom={1}>
      <Typography component="h2" variant="h5">
        {isEdit ? 'Uppdatera inlägg' : 'Skapa nytt inlägg'}
      </Typography>
      <FullWidthForm noValidate onSubmit={submit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="title"
          name="title"
          label="Rubrik"
          autoFocus
          defaultValue={existingItem ? existingItem.title : ''}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="description"
          name="description"
          defaultValue={existingItem ? existingItem.description : ''}
          label="Brödtext"
          rows={4}
          multiline
        />
{
              permissions.map((item) => {
                return (
                  <FormControlLabel
                  key={item.id}
                  control={
                    <Switch
                      // @ts-ignore
                      checked={!!state[item.id]}
                      onChange={(event) => {
                        setState((s) => ({
                          ...s,
                          [item.id]: event.target.checked,
                        }));
                      }}
                    />
                  }
                  label={item.name}
                />
                )
              })
            }
        <DialogActions>
          <Button color="secondary" type="button" onClick={onCancel}>
            {'Avbryt'}
          </Button>
          <Button color="primary" type="submit">
            {isEdit ? 'Spara pushnotis' : 'Skapa ny pushnotis'}
          </Button>
        </DialogActions>
      </FullWidthForm>
    </Box>
  );
});
